<template>
  <li :class="[last ? '' : 'pb-2', isAuthor ? 'pl-12' : 'pr-12']">
    <div class="relative" :class="[last ? '' : 'pb-8']">
      <div class="relative flex items-start space-x-3">
        <div class="min-w-0 flex-1">
          <div>
            <div class="text-sm" :class="[isAuthor ? 'text-right' : 'text-left']">
              <a href="#" class="font-medium text-gray-900">{{
                isAuthor ? 'Me' : authorable.fullName
              }}</a>
            </div>
            <p
              class="mt-0.5 text-xs text-gray-500"
              :class="[isAuthor ? 'text-right' : 'text-left']"
            >
              Sent {{ sendAt }}
            </p>
          </div>
          <div
            class="mt-2 text-sm text-gray-700 rounded p-2"
            :class="[isAuthor ? 'bg-blue-100 text-right' : 'bg-green-100 text-left']"
          >
            <p>
              {{ message.content }}
            </p>
          </div>
          <div
            v-if="hasMessageThirdPartyServices"
            class="mt-2"
            :class="[isAuthor ? 'text-right' : 'text-left']"
          >
            <MessageItemMessageThirdPartyServices
              :message-third-party-services="messageThirdPartyServices"
            />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import moment from 'moment';
import MessageItemMessageThirdPartyServices from './MessageItemMessageThirdPartyServices.vue';

export default {
  components: {
    MessageItemMessageThirdPartyServices,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    last: Boolean,
  },
  computed: {
    authorable() {
      return this.$store.state.entities[this.message.authorableType].byId[
        this.message.authorableId
      ];
    },
    isAuthor() {
      return this.$user.id === this.authorable.id;
    },
    sendAt() {
      return moment(this.message.createdAt).fromNow();
    },
    hasMessageThirdPartyServices() {
      return Array.isArray(this.message?.messageThirdPartyServices);
    },
    messageThirdPartyServices() {
      return this.hasMessageThirdPartyServices ? this.message.messageThirdPartyServices : [];
    },
  },
};
</script>
